import { render, staticRenderFns } from "./NewDefinition.vue?vue&type=template&id=dbf82470&scoped=true&"
import script from "./NewDefinition.vue?vue&type=script&lang=js&"
export * from "./NewDefinition.vue?vue&type=script&lang=js&"
import style0 from "./NewDefinition.vue?vue&type=style&index=0&id=dbf82470&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbf82470",
  null
  
)

component.options.__file = "NewDefinition.vue"
export default component.exports